import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const CoinBoxWrapper = styled.div`
  display: flex;
  gap: 2rem;
  padding-left: 1rem;
  margin-top: 2rem;
  ${({ theme }) => theme.media.laptop`
      gap: unset;
  `};
`;

export const BodyLoader = styled(ContentLoader)`
  height: 18rem;
  width: 18.5rem;
  background-color: ${({ theme }) => theme.colors.text.interactive};
  border-radius: ${({ theme }) => theme.borderRadius.high};

  ${({ theme }) => theme.media.laptop`
      height: 18.5rem;
      width: 15.5rem;
  `};
`;

export const AssetIcon = styled.circle`
  r: 1.7rem;
  cx: 2.7rem;
  cy: 3.4rem;

  ${({ theme }) => theme.media.mobileL`
      cx: 3.8rem;
  `};

  ${({ theme }) => theme.media.laptop`
      cx: 3rem;
      cy: 5rem;
      r: 2rem;
  `};
`;

export const AssetName = styled.rect`
  height: 1.8rem;
  width: 7rem;

  x: 1.4rem;
  y: 5.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 1rem;
    y: 8rem;
  `};
`;

export const Percentage = styled.rect`
  height: 1.3rem;
  width: 8rem;

  y: 12.5rem;
  x: 7%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
  ${({ theme }) => theme.media.laptop`
      y: 14.5rem;
      x: 7%;
  `};
`;

export const Amount = styled.rect`
  height: 2rem;
  width: 7rem;

  y: 10rem;
  x: 7%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
  ${({ theme }) => theme.media.laptop`
      y: 12rem;
      x: 7%;
  `};
`;
